import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { RemoveRedEye } from "@mui/icons-material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { userShiftCategoryHeader } from "pages/Administration/AdministrationHeaders";
import { Loader } from "components/Loader";
import { TableEmptyState } from "components/CustomComponents/EmptyState";


export const ShiftCategory = ({
  setIsViewPanelOpen,
  setUserData,
  userShiftCategoryDetails,
  setUserShiftCategoryDetails,
  trigger,
  setTrigger,
  setCategoryData,
  page,
  setPage,
  headers = userShiftCategoryHeader,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { result: userShiftCategoryData, loading: userShiftCategoryLoading } =
    useFetch(
      `${domain}administration/shiftroster/userassignment/shiftcategory/shift-category-details/?company_id=${requestCompanyId}`
    );

  const containerRef = useRef(null);
  const sortedShiftCategoryData = userShiftCategoryData?.data?.sort((a, b) => {
    const dateA = new Date(a.effective_from);
    const dateB = new Date(b.effective_from);
    if (dateA < dateB) return 1;
    if (dateA > dateB) return -1;
    const assignNameA = a.employee_name || "";
    const assignNameB = b.employee_name || "";
    return assignNameA.localeCompare(assignNameB, undefined, {
      numeric: true,
    });
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (
      (sortedShiftCategoryData?.length !== 0 ||
        sortedShiftCategoryData?.length === 0) &&
      trigger &&
      sortedShiftCategoryData
    ) {
      setUserShiftCategoryDetails(sortedShiftCategoryData);
      setCategoryData(sortedShiftCategoryData);
      setTrigger(false);
    }
  }, [
    globalSearchValue,
    page,
    setCategoryData,
    setTrigger,
    setUserShiftCategoryDetails,
    sortedShiftCategoryData,
    trigger,
  ]);

  return userShiftCategoryLoading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Mui.Grid
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mr: 2,
        }}
      >
        <Mui.Typography sx={{ fontWeight: 600 }}>
          Total Number of Employee :{" "}
          {userShiftCategoryDetails
            ? new Set(userShiftCategoryDetails.map((item) => item.user_id)).size
            : 0}
        </Mui.Typography>
      </Mui.Grid>
      {userShiftCategoryLoading ? (
        <Loader />
      ) : (
        <Mui.Grid container>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ mt: 2, width: "100%", ml: 2, mr: 2, maxHeight: 520 }}
            id="Shift_grade_table"
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow
                  sx={{
                    "& .MuiTableCell-root": {
                      height: "10px",
                      padding: "3px 15px",
                    },
                  }}
                >
                  {headers?.map((head) => (
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      {head.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {userShiftCategoryDetails?.length === 0 &&
                !userShiftCategoryLoading ? (
                  <TableEmptyState dataLength={sortedShiftCategoryData} />
                ) : (
                  userShiftCategoryDetails
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((shift_category_users) => (
                      <React.Fragment>
                        <Mui.TableRow
                          sx={{
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: "3px 15px",
                            },
                          }}
                        >
                          {headers?.map((head) =>
                            head.key === "" ? (
                              <Mui.TableCell>
                                <Mui.Stack direction="row">
                                  <Mui.IconButton
                                    onClick={() => {
                                      setIsViewPanelOpen(true);
                                      setUserData(shift_category_users);
                                    }}
                                  >
                                    <RemoveRedEye
                                      sx={{
                                        cursor: "pointer",
                                        color: themes?.mutedgreen,
                                      }}
                                    />
                                  </Mui.IconButton>
                                </Mui.Stack>
                              </Mui.TableCell>
                            ) : (
                              <Mui.TableCell>
                                {head.key === "effective_from" ||
                                head.key === "effective_to" ? (
                                  shift_category_users[head.key] ? (
                                    shift_category_users[head.key]
                                  ) : (
                                    "N/A"
                                  )
                                ) : head?.key === "employee_name" ? (
                                  <Mui.Stack direction="Row">
                                    <Mui.Avatar
                                      sx={{ width: 23, height: 23 }}
                                      alt={shift_category_users?.employee_name
                                        ?.charAt(0)
                                        .toUpperCase()}
                                      src={
                                        shift_category_users?.image_url ??
                                        optionalAvathar
                                      }
                                    />
                                    &nbsp;
                                    {shift_category_users?.employee_name}
                                  </Mui.Stack>
                                ) : shift_category_users[head.key] ? (
                                  shift_category_users[head.key]
                                ) : (
                                  "N/A"
                                )}
                              </Mui.TableCell>
                            )
                          )}
                        </Mui.TableRow>
                      </React.Fragment>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
        </Mui.Grid>
      )}
      {userShiftCategoryDetails?.length > 25 && (
        <Mui.Box sx={{ mt: 1 }}>
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={userShiftCategoryDetails?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Mui.Box>
      )}
    </React.Fragment>
  );
};
